<template>
  <v-autocomplete
    :id="`search-term-${props.data.searchId}`"
    v-model="selectedItem"
    class="lh--force-white-background"
    :items="items"
    :label="props.data.label + (props.required ? '*' : '')"
    :placeholder="props.data.label"
    :disabled="props.disabled"
    :clearable="true"
    :return-object="true"
    :allow-free-text-input="props.allowFreeTextInput"
    :menu-props="{
      contentClass: 'medication-autocomplete-menu',
      maxHeight: 300,
      position: 'absolute',
      transition: false,
      closeOnClick: true,
      closeOnContentClick: true,
      eager: true,
      offsetY: true,
      offsetOverflow: true,
      location: 'bottom',
    }"
    @update:model-value="handleSelection"
    @keyup.enter="handleEnterKey"
    @keyup.esc="cleanInput">
    <template #item="{ props: itemProps, item }">
      <v-list-item v-bind="itemProps">
        <v-list-item-title>
          {{ item.raw.label }}
          <span v-if="item.raw.additionalInfo" class="text-caption text-medium-emphasis">
            [{{ item.raw.additionalInfo }}]
          </span>
        </v-list-item-title>
      </v-list-item>
    </template>
  </v-autocomplete>
</template>

<script setup>
import { ref, computed } from "vue";

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
  required: {
    type: Boolean,
    required: false,
  },
  allowFreeTextInput: {
    type: Boolean,
    default() {
      return false;
    },
  },
  disabled: {
    type: Boolean,
    default() {
      return false;
    },
  },
});

const emit = defineEmits(["item-selected"]);

const selectedItem = ref(null);

const items = computed(() => {
  return props.data.options.map((option) => ({
    title: option.label,
    value: option,
    raw: option,
  }));
});

function handleSelection(item) {
  if (item) {
    emit("item-selected", item);
  }
}

function handleEnterKey(event) {
  if (props.allowFreeTextInput && event.target.value) {
    const freeTextItem = {
      label: event.target.value,
      value: { medication: event.target.value },
    };
    emit("item-selected", freeTextItem);
  }
}

function cleanInput() {
  selectedItem.value = null;
}
</script>

<style lang="scss" scoped>
@import "../styles/pages/_patient-information-form.scss";
@import "../styles/pages/_insurance-navigator-page";

.medication-autocomplete-menu {
  position: absolute !important;
  z-index: 1000;
  transform: none !important;
  will-change: transform;
  backface-visibility: hidden;
  perspective: 1000px;
}
</style>
